














import {
  createComponent,
  inject,
  onMounted,
  computed
} from "@vue/composition-api";
import DisplayUIKey from "@/components/display-ui-key";

const errorItem: { [key: string]: string; } = {
  "mail": "メールアドレス",
  "password": "パスワード",
  "detail":"詳細",
  "zipcode":"郵便番号",
  "company_name":"企業名",
  "company_name_furigana":"企業名(フリガナ)",

  "branch_name":"支社名",
  "industry_code":"業種",
  "representative_name":"代表者名",
  "representative_name_furigana":"代表者名(フリガナ)",
  "person_in_charge_name":"担当者名",
  "person_in_charge_furigana":"担当者名(フリガナ)",
  "address_1":"町域までの住所",
};

export default createComponent({
  props: {
	  errorMessage: {
      type: Object
    },
    closeErrorDialog: {
      type: Function
    }
  } as const,
  computed:{
    dispErrorMessage:function(){
      //@ts-ignore
      var originalMessageData = this.errorMessage.data
      var keys = Object.keys(originalMessageData);
      var returnMessage = ''
      keys.filter(key => {
        var originalMessage = originalMessageData[key];
        var dispKey:string = key;
        if (errorItem[dispKey]){
          dispKey = errorItem[dispKey]
        }
        returnMessage += '<br>' + dispKey + '：' + originalMessageData[key];
      })
    return returnMessage
    return 
    }
  },
  setup() {
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }

    onMounted(() => {});
    return {

    };
  },
  components: {}
});
